


















































































import CompanySheet from "@/components/company/CompanySheet.vue";
import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import { PreselectTemplateKeysEnum } from "@/lib/enum/preselect-template-keys.enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { MrfiktivCustomFieldConfigurationElementDtoGen } from "@/services/mrfiktiv/v1/data-contracts";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import { SharedContent } from "@/models/shared-content.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { Reference } from "@/models/reference.entity";

export enum Steps {
  FORM = "form",
  SEND_MAIL = "sendMail"
}

@Component({
  components: { PreselectTemplateCard, CompanySheet, MNoContent },
  filters: {}
})
export default class PartnerReportStatusHistoryAddDialog extends mixins(PermissionMixin) implements IDialog {
  readonly Steps = Steps;
  readonly PreselectTemplateKeysEnum = PreselectTemplateKeysEnum;

  @Ref("templateCard")
  templateCard!: PreselectTemplateCard;

  @Prop({ default: false }) value!: boolean;
  dialog: boolean = this.value;

  @Watch("value")
  onValueChange(val: boolean) {
    this.dialog = val;
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  step = Steps.FORM;

  get customFieldStatus() {
    return this.report?.group?.configuration?.status?.customField?.configuration?.values ?? [];
  }

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get currentStatus() {
    return this.report.statusHistory?.length
      ? this.report.statusHistory[this.report.statusHistory.length - 1].status
      : "";
  }

  get context() {
    return {
      partner: this.partner,
      report: this.report,
      status: this.currentStatus,
      url: {
        sharing: this.report.person?.activeSharedContent?.url,
        publicReportUrl: this.report.person?.activeSharedContent?.url
      }
    };
  }

  get validForm() {
    return this.newStatus;
  }

  get toMail() {
    return this.report.person?.primaryEmail ? [this.report.person.primaryEmail] : [];
  }

  newStatus: MrfiktivCustomFieldConfigurationElementDtoGen | string = "";
  message = "";
  isProgressStatusLoading = false;

  get autocompleteFilter() {
    return getAutocompleteFilter((e: MrfiktivCustomFieldConfigurationElementDtoGen) => {
      const filters = [];
      filters.push(e.value);
      if (e.description) {
        filters.push(e.description);
      }
      return filters;
    });
  }

  onStatusChange(event: string) {
    const status = this.customFieldStatus.find(v => v.value === event);
    if (status?.description) {
      this.message = status.description;
    }
  }

  async updateStatus() {
    const newStatus =
      (this.newStatus as MrfiktivCustomFieldConfigurationElementDtoGen).value ?? (this.newStatus as string);
    this.isProgressStatusLoading = true;
    await this.report.setProgressWithHistory(newStatus, this.message);

    this.newStatus = "";
    this.message = "";
    this.isProgressStatusLoading = false;
  }

  async createAndClose() {
    try {
      await this.updateStatus();
      this.close();
    } catch (e) {
      handleError(e);
    }
  }

  async createReportAndSend() {
    try {
      await this.updateStatus();

      if (!this.report.person?.activeSharedContent?.url && this.canReadActivity) {
        this.report.person?.fetchSharedContent(this.report.id);

        /**
         * if shared content not defined after loading, create new one
         */
        if (this.report.person && !this.report.person?.activeSharedContent && this.canCreateActivity) {
          this.report.person.activeSharedContent = new SharedContent({
            partnerId: this.partner.id,
            reportId: this.report.id,
            personIds: [this.report.person.id],
            emailAddresses: this.report.person?.primaryEmail ? [this.report.person.primaryEmail] : [],
            refs: [new Reference({ refId: this.report.id, refType: ResourceEnum.REPORT })]
          });

          await this.report.person.activeSharedContent.create();
        }
      }

      this.step = Steps.SEND_MAIL;
    } catch (e) {
      handleError(e);
    }
  }

  async sendMail() {
    await this.templateCard?.send();
    this.close();
  }

  async close() {
    this.dialog = false;
    this.reset();
  }

  open() {
    this.reset();
    this.dialog = true;
  }

  reset() {
    this.step = Steps.FORM;
    this.newStatus = "";
  }
}
